<template>
  <b-badge pill :variant="`light-${recordStatusVariant(data)}`" class="text-capitalize">
    {{ isDefaultFormat(data) }}
  </b-badge>
</template>

<script>
import {recordStatusVariant, isDefaultFormat} from "@core/utils/filter";
import {BBadge} from "bootstrap-vue";

export default {
  components: {BBadge},
  methods: {
    isDefaultFormat,
    recordStatusVariant,
  },
  props: ['data'],
}
</script>

<style scoped>

</style>